import React from "react";
import "./Header.scss";
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
import { headerDescription, Locations, PageHeaders } from "../../Constants/constants";
import HeaderHeading from "./HeaderHeading/HeaderHeading";

let title = "";
let content = "";
let nameIcon = "";
let nameIconFirstLetter = "";
let nameIconSecondLetter = "";

const Header = () => {
  const location = useLocation();
  const { accounts } = useMsal();

  const name = accounts[0]?.name;

  if (name) {
    nameIconFirstLetter = name.substring(0, 1);
    nameIconSecondLetter = name.substring(name.indexOf(" ") + 1, name.indexOf(" ") + 2);
    nameIcon = nameIconFirstLetter.concat(nameIconSecondLetter);
  }

  const headerDetails = () => {
    if (location.pathname === Locations.OrgLocation) {
      title = PageHeaders.Organization;
      content = headerDescription.orgDesc;
    }

    if (location.pathname === Locations.ResLocation) {
      title = PageHeaders.Resource;
      content = headerDescription.resDesc;
    }

    return <HeaderHeading heading={title} headingContent={content} />;
  };

  return (
    <div className="partner-portal-header">
      <div>{headerDetails()}</div>
      <div className="header-user-info">
        <div className="header-name-svg">
          <div className="header-name-svg-font">
            <div>{nameIcon}</div>
          </div>
        </div>
        <div className="header-user-name">{name}</div>
      </div>
    </div>
  );
};

export default Header;
